import { render, staticRenderFns } from "./CreateGame.vue?vue&type=template&id=c16230e0&scoped=true"
import script from "./CreateGame.vue?vue&type=script&lang=js"
export * from "./CreateGame.vue?vue&type=script&lang=js"
import style0 from "./CreateGame.vue?vue&type=style&index=0&id=c16230e0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c16230e0",
  null
  
)

export default component.exports